import React from "react";
import {
  ForgotPasswordForm,
  ForgotPasswordSuccess,
  ForgotPasswordHeader,
} from "../../components/auth";
import { useForgotPassword } from "../../hooks/useForgotPassword";

interface ForgotPasswordProps {
  onBackToLogin: () => void;
}

const ForgotPassword: React.FC<ForgotPasswordProps> = ({ onBackToLogin }) => {
  const { isSubmitted, isLoading, submitEmail } = useForgotPassword();

  if (isSubmitted) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <ForgotPasswordSuccess onBackToLogin={onBackToLogin} />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <ForgotPasswordHeader
          title="Quên mật khẩu"
          subtitle="Nhập email của bạn để nhận link đặt lại mật khẩu"
        />

        <ForgotPasswordForm
          onSubmit={submitEmail}
          isLoading={isLoading}
          onBackToLogin={onBackToLogin}
        />
      </div>
    </div>
  );
};

export default ForgotPassword;
